import React, {
    useEffect,
    useState
} from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";

import "./IgniteHeader.css";

import {
    ChevronDown
} from "lucide-react";


const IgniteHeader = ({
    title,
    subtitle
}) => {

  const navigate = useNavigate();
    /* =====================================================
       EMAIL
    ===================================================== */

    const email =
        localStorage.getItem(
            "user_email"
        );


    /* =====================================================
       USER STATE
    ===================================================== */

    const [
        user,
        setUser
    ] = useState(null);


    /* =====================================================
       CURRENT LEVEL
       From Ignite Journey API
    ===================================================== */

    const [
        currentLevel,
        setCurrentLevel
    ] = useState(1);


    /* =====================================================
       PROFILE PHOTO
    ===================================================== */

    const [
        profilePhoto,
        setProfilePhoto
    ] = useState(

        localStorage.getItem(
            "profile_photo"
        ) || ""

    );


    /* =====================================================
       LOADING
    ===================================================== */

    const [
        loading,
        setLoading
    ] = useState(true);


    /* =====================================================
       LEVEL NAMES
    ===================================================== */

    const levelNames = {

        1: "ROOKIE",

        2: "CONTENDER",

        3: "PERFORMER",

        4: "ELITE"

    };


    /* =====================================================
       LOAD PROFILE + IGNITE CURRENT LEVEL
    ===================================================== */

    useEffect(() => {

        if (!email) {

            setLoading(false);

            return;

        }


        loadHeaderData();


    }, [email]);


    /* =====================================================
       FETCH HEADER DATA
    ===================================================== */

    const loadHeaderData =
        async () => {

            try {

                setLoading(true);


                /* =========================================
                   PROFILE API
                ========================================= */

                const profileRes =
                    await axios.get(

                        `/api/ignite/profile/${encodeURIComponent(
                            email
                        )}`

                    );


                console.log(
                    "IGNITE PROFILE RESPONSE:",
                    profileRes.data
                );


                if (
                    profileRes.data?.success
                ) {

                    const apiUser =
                        profileRes.data?.user ||
                        {};


                    setUser(
                        apiUser
                    );


                    /* =====================================
                       PROFILE PHOTO
                    ===================================== */

                    const photo =
                        apiUser?.profilePhoto ||
                        "";


                    if (photo) {

                        setProfilePhoto(
                            photo
                        );


                        localStorage.setItem(
                            "profile_photo",
                            photo
                        );

                    }

                }


                /* =========================================
                   IGNITE JOURNEY API
                   
                   CURRENT LEVEL COMES FROM:
                   
                   levelObjectives.currentLevel
                ========================================= */

                const journeyRes =
                    await axios.get(

                        `/api/ignite/journey/${encodeURIComponent(
                            email
                        )}`

                    );


                console.log(
                    "IGNITE JOURNEY RESPONSE:",
                    journeyRes.data
                );


                const backendLevel =
                    Number(

                        journeyRes.data
                            ?.levelObjectives
                            ?.currentLevel

                    ) || 1;


                console.log(
                    "CURRENT IGNITE LEVEL:",
                    backendLevel
                );


                /* =====================================
                   UPDATE STATE
                ===================================== */

                setCurrentLevel(
                    backendLevel
                );


                /* =====================================
                   OPTIONAL LOCAL STORAGE
                ===================================== */

                localStorage.setItem(
                    "ignite_current_level",
                    String(
                        backendLevel
                    )
                );

            }

            catch (err) {

                console.error(

                    "Ignite Header Error:",

                    err

                );

            }

            finally {

                setLoading(false);

            }

        };


    /* =====================================================
       PROFILE UPDATE EVENT
    ===================================================== */

    useEffect(() => {

        const handleProfileUpdate =
            (event) => {


                console.log(

                    "PROFILE UPDATED EVENT:",

                    event.detail

                );


                /* =========================================
                   PROFILE PHOTO UPDATED
                ========================================= */

                if (
                    event.detail?.photo
                ) {

                    const newPhoto =
                        event.detail.photo;


                    setProfilePhoto(
                        newPhoto
                    );


                    localStorage.setItem(
                        "profile_photo",
                        newPhoto
                    );


                    setUser(
                        previous => ({

                            ...previous,

                            profilePhoto:
                                newPhoto

                        })

                    );

                }


                /* =========================================
                   LEVEL UPDATED
                   
                   If another page sends level,
                   update header immediately.
                ========================================= */

                if (
                    event.detail?.level !==
                    undefined
                ) {

                    const newLevel =
                        Number(
                            event.detail.level
                        );


                    setCurrentLevel(
                        newLevel
                    );


                    localStorage.setItem(
                        "ignite_current_level",
                        String(
                            newLevel
                        )
                    );

                }

            };


        window.addEventListener(

            "profileUpdated",

            handleProfileUpdate

        );


        return () => {

            window.removeEventListener(

                "profileUpdated",

                handleProfileUpdate

            );

        };

    }, []);


    /* =====================================================
       GREETING
    ===================================================== */

    const getGreeting = () => {

        const hour =
            new Date().getHours();


        if (
            hour < 12
        ) {

            return "Good Morning";

        }


        if (
            hour < 17
        ) {

            return "Good Afternoon";

        }


        return "Good Evening";

    };


    /* =====================================================
       IMAGE ERROR
    ===================================================== */

    const handleImageError =
        (event) => {

            console.error(

                "Profile image failed:",

                profilePhoto

            );


            event.currentTarget.src =
                "/Hero/profile.png";

        };


    /* =====================================================
       LOADING
    ===================================================== */

    if (loading) {

        return (

            <header
                className="ignite-header"
            >

                Loading...

            </header>

        );

    }


    /* =====================================================
       CURRENT LEVEL NAME
    ===================================================== */

    const levelName =
        levelNames[
            currentLevel
        ] || "ROOKIE";


    /* =====================================================
       RENDER
    ===================================================== */

    return (

        <header
            className="ignite-header"
        >


            {/* =================================================
               LEFT
            ================================================= */}

            <div
                className="ignite-header-left"
            >

                <span
                    className="ignite-greeting"
                >

                    {getGreeting()}

                    {", "}

                    <strong>

                        {
                            user?.name ||
                            "Athlete"
                        }

                    </strong>

                    👋

                </span>


                <h1>

                    {title}

                </h1>


                <p>

                    {subtitle}

                </p>

            </div>


            {/* =================================================
               RIGHT
            ================================================= */}

            <div
                className="ignite-header-right"
            >

                 <button
        className="ignite-profile"
        type="button"
        onClick={() => navigate("/ignite/profile")}
    >


                    {/* =========================================
                       PROFILE PHOTO
                    ========================================= */}

                    <img

                        src={

                            profilePhoto ||

                            "/Hero/profile.png"

                        }

                        alt="profile"

                        onError={
                            handleImageError
                        }

                    />


                    {/* =========================================
                       USER INFO
                    ========================================= */}

                    <div
                        className="ignite-user-info"
                    >

                        <h4>

                            {
                                user?.name ||
                                "Athlete"
                            }

                        </h4>


                        {/* =====================================
                           CURRENT LEVEL
                        ===================================== */}

                        <span>

                            LEVEL{" "}

                            {currentLevel}

                            {" : "}

                            {levelName}

                        </span>

                    </div>


                    <ChevronDown
                        size={18}
                    />

                </button>

            </div>


        </header>

    );

};


export default IgniteHeader;